import { httpsCallable } from 'firebase/functions'
import { functions } from './config'
import { LEGAL_CLIENT_ID } from '@/constants/legal'
import type {
  AcceptLegalTermsRequest,
  AcceptLegalTermsResponse,
  LegalChannel,
  LegalTermsErrorCode,
} from '@/types'

/**
 * Adaptador delgado de la callable `acceptLegalTerms` — la ÚNICA Cloud Function
 * que invoca el portal (ADR-SEC-013 local). Contrato (réplica):
 * `specs/API-CONTRACT/accept-legal-terms.md`. El portal nunca escribe el
 * consentimiento directamente: las reglas lo niegan en `users` y `consents`.
 */
export const callAcceptLegalTerms = async (
  acceptedVersion: string,
  channel: LegalChannel
): Promise<AcceptLegalTermsResponse> => {
  const callable = httpsCallable<AcceptLegalTermsRequest, AcceptLegalTermsResponse>(
    functions,
    'acceptLegalTerms'
  )
  const result = await callable({
    accepted_version: acceptedVersion,
    channel,
    client: LEGAL_CLIENT_ID,
  })
  return result.data
}

/**
 * `details.code` de un error de la callable, si es uno de los que el cliente
 * distingue. Nunca se decide por `message` (no se muestra al usuario).
 */
export const getLegalTermsErrorCode = (error: unknown): LegalTermsErrorCode | null => {
  if (typeof error !== 'object' || error === null || !('details' in error)) return null
  const details = (error as { details: unknown }).details
  if (typeof details !== 'object' || details === null) return null
  const code = (details as { code?: unknown }).code
  return code === 'LEGAL_VERSION_MISSING' ||
    code === 'TERMS_VERSION_OUTDATED' ||
    code === 'USER_NOT_PROVISIONED'
    ? code
    : null
}
